/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResourceStatusDto } from './ResourceStatusDto';
import {
    ResourceStatusDtoFromJSON,
    ResourceStatusDtoFromJSONTyped,
    ResourceStatusDtoToJSON,
} from './ResourceStatusDto';

/**
 * 
 * @export
 * @interface DeploymentStatusDto
 */
export interface DeploymentStatusDto {
    /**
     * The resource.
     * @type {Array<ResourceStatusDto>}
     * @memberof DeploymentStatusDto
     */
    resources: Array<ResourceStatusDto>;
}

/**
 * Check if a given object implements the DeploymentStatusDto interface.
 */
export function instanceOfDeploymentStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resources" in value;

    return isInstance;
}

export function DeploymentStatusDtoFromJSON(json: any): DeploymentStatusDto {
    return DeploymentStatusDtoFromJSONTyped(json, false);
}

export function DeploymentStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resources': ((json['resources'] as Array<any>).map(ResourceStatusDtoFromJSON)),
    };
}

export function DeploymentStatusDtoToJSON(value?: DeploymentStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resources': ((value.resources as Array<any>).map(ResourceStatusDtoToJSON)),
    };
}

